<ichannel-button
  [icon]="'SORT'"
  [label]=""
  [theme]="'IC'"
  [callback]="filterToggleCallback"
  [customButtonStyle]="{
    'background-color': 'white',
    padding: '4px 9px 0px 9px',
    'min-width': 'auto'
  }"
  [reactive]="true"
></ichannel-button>
